<template>
  <div>
    <v-card class="transparent" flat>
      <v-card-title
        v-if="!helpers.dataIsLoading"
        class="px-0"
        :class="
          $vuetify.breakpoint.smAndDown ? 'subtitle-1 font-weight-medium' : ''
        "
        >Meine letzten Dienstberichte<v-spacer></v-spacer>
        <v-btn
          text
          outlined
          small
          :to="{
            name: 'duty-management-reports',
          }"
          >Alle anzeigen</v-btn
        >
      </v-card-title>
      <div>
        <v-skeleton-loader
          v-if="helpers.dataIsLoading"
          elevation="2"
          type="card-heading, list-item-two-line, divider, card-heading, list-item-two-line, divider, card-heading, list-item-two-line"
        ></v-skeleton-loader>
        <v-data-iterator
          v-else
          :items="reports"
          no-data-text="Keine Dienstberichte vorhanden"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-card>
              <v-row no-gutters>
                <v-col
                  v-for="(report, index) in props.items"
                  :key="index"
                  cols="12"
                >
                  <v-list-item
                    :to="{
                      name: 'duty-management-reports-details',
                      params: { itemId: report.meta.id },
                    }"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        <span v-if="report.title">{{ report.title }}</span>
                        <span v-else class="grey--text"
                          >Bericht ohne Titel</span
                        >
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <p style="line-height: 1.6" class="mb-0">
                          <v-icon small left>mdi-circle</v-icon
                          >{{ report.type.title }}
                          <br />
                          <v-icon small left>mdi-clock-start</v-icon
                          ><span
                            :class="
                              !report.duration.start.timestamp
                                ? 'grey--text'
                                : ''
                            "
                          >
                            {{
                              report.duration.start.timestamp
                                ? timestampConverter(
                                    report.duration.start.timestamp
                                  )
                                : "Nicht festgelegt"
                            }}</span
                          >
                          <br />
                          <v-icon small left>mdi-clock-end</v-icon
                          ><span
                            :class="
                              !report.duration.end.timestamp ? 'grey--text' : ''
                            "
                          >
                            {{
                              report.duration.end.timestamp
                                ? timestampConverter(
                                    report.duration.end.timestamp
                                  )
                                : report.duration.end.estimatedTimestamp
                                ? "Erwartet:"
                                : ""
                            }}
                            <br
                              v-if="
                                !report.duration.end.timestamp &&
                                report.duration.end.estimatedTimestamp
                              "
                            />
                            {{
                              report.duration.end.estimatedTimestamp
                                ? timestampConverter(
                                    report.duration.end.estimatedTimestamp
                                  )
                                : !report.duration.end.timestamp
                                ? "Nicht festgelegt"
                                : ""
                            }}</span
                          >
                        </p>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <report-status-chip :status="report.status" small>
                      </report-status-chip>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="props.items.length != index + 1"></v-divider>
                </v-col>
              </v-row>
            </v-card>
          </template>
        </v-data-iterator>
      </div>
    </v-card>
  </div>
</template>

<script>
import { DUTY_MANAGEMENT } from "@/store/modules.js";
import { GET_REPORTS } from "@/store/action-types.js";
// import DutyTypeChip from "@/components/duty-management/DutyTypeChip.vue";
import ReportStatusChip from "@/components/duty-management/ReportStatusChip.vue";
export default {
  name: "self-service-open-duty-reports",
  props: {},
  components: {
    // DutyTypeChip,
    ReportStatusChip,
  },
  data() {
    return {
      helpers: {
        dataIsLoading: false,
      },
    };
  },
  computed: {
    reports() {
      return this.$store.state.dutyManagement.reports;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch(`${DUTY_MANAGEMENT}${GET_REPORTS}`, {
        organizationId: this.$route.params.organizationId,
        query: {
          queryIsFiltered: true,
          onlyOwn: true,
        },
        paginationLimit: 3,
      });
    },
    timestampConverter(timestamp) {
      const options = {
        weekday: "short",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
  },
};
</script>
